(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-mega-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__custom_mega_header_drawer_inited_v2) return;
  window.__custom_mega_header_drawer_inited_v2 = true;

  function findClosestDrawer(el){
    if (!el) return null;
    var header = el.closest && el.closest('.custom-mega-header');
    // prefer the actual mobile drawer element inside header__drawer
    var drawer = header ? header.querySelector('.header__drawer .mobile-custom-drawer') : null;
    if (!drawer && header) drawer = header.querySelector('.mobile-custom-drawer');
    if (!drawer) drawer = document.querySelector('.header__drawer .mobile-custom-drawer');
    if (!drawer) drawer = document.querySelector('.mobile-custom-drawer');
    return drawer;
  }

  function openDrawer(drawer){
    if (!drawer) return;
    // if drawer is inside a <details>, open it properly
    var details = drawer.closest('details');
    if (details) {
      try { details.open = true; details.setAttribute('open',''); details.dispatchEvent(new Event('open')); } catch(e){}
    }
    // use explicit display to avoid layout reflow surprises
    drawer.style.display = 'block';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('custom-drawer-open');

    // focus first focusable element for accessibility
    var focusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
    else if (drawer.focus) drawer.focus();
  }

  function closeDrawer(drawer){
    if (!drawer) return;
    var details = drawer.closest('details');
    if (details) {
      try { details.open = false; details.removeAttribute('open'); details.dispatchEvent(new Event('close')); } catch(e){}
    }
    drawer.style.display = 'none';
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('custom-drawer-open');
  }

  // Open/close when clicking the hamburger
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-open-drawer]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var drawer = findClosestDrawer(btn);
    if (!drawer) {
      console.warn('Custom Mega Header: .mobile-custom-drawer not found.');
      return;
    }

    var isOpen = drawer.classList.contains('is-open');
    if (isOpen) closeDrawer(drawer);
    else openDrawer(drawer);
  }, {passive:false});

  // delegated close: any element with data-custom-close
  document.addEventListener('click', function(e){
    var closeBtn = e.target.closest && e.target.closest('[data-custom-close]');
    if (!closeBtn) return;
    var drawer = findClosestDrawer(closeBtn) || document.querySelector('.mobile-custom-drawer');
    if (!drawer) return;
    e.preventDefault();
    e.stopPropagation();
    closeDrawer(drawer);
  }, {passive:false});

  // ESC to close
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' || e.key === 'Esc') {
      var drawer = document.querySelector('.mobile-custom-drawer.is-open');
      if (drawer) closeDrawer(drawer);
    }
  });

  // Dev helpers
  try { window.__customDrawer = { open: openDrawer, close: closeDrawer, find: findClosestDrawer }; } catch(e){}
})();

/* ==============================
   STICKY HEADER SCROLL LOGIC
   ============================== */
/* ==============================
   STICKY HEADER ON SCROLL
   ============================== */
(function () {
  var header = document.querySelector('.custom-mega-header');
  if (!header) return;

  function onScroll() {
    if (window.scrollY > 0) {
      header.classList.add('is-sticky-active');
    } else {
      header.classList.remove('is-sticky-active');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".dis-faq-item");

  items.forEach(item => {
    const btn = item.querySelector(".dis-faq-button");
    const ans = item.querySelector(".dis-faq-answer");
    const inner = item.querySelector(".dis-faq-answer-inner");

    btn.addEventListener("click", () => {
      const open = item.classList.contains("active");

      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".dis-faq-answer").style.maxHeight = "0";
      });

      if (!open) {
        item.classList.add("active");
        requestAnimationFrame(() => {
          ans.style.maxHeight = inner.scrollHeight + "px";
        });
      }
    });
  });

  /* ⭐ OPEN FIRST FAQ BY DEFAULT */
  const first = items[0];
  if (first) {
    const ans = first.querySelector(".dis-faq-answer");
    const inner = first.querySelector(".dis-faq-answer-inner");
    first.classList.add("active");
    ans.style.maxHeight = inner.scrollHeight + "px";
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
